import {
    Box,
    Button,
    Container,
    Flex,
    Grid,
    GridItem,
    Image,
    List,
    Spinner,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import Head from "next/head";
import React, { useEffect, useState } from "react";

import CardItem from "@/components/codigo-conducta/Card";
import Sidebar from "@/sections/estandares-codigo/Sidebar";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const CodigoConducta = () => {
    const carouselData = [
        {
            id: 1,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/P-Errejon.jpg",
            name: "Pablo Errejón",
            job_position: "CEO",
        },
        {
            id: 2,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/M-Errejon.jpg",
            name: "Mariana Errejón",
            job_position: "Brand License Manager",
        },
        {
            id: 3,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/A-Dibildox.jpeg",
            name: "Alejandro Dibildox",
            job_position: "Chief Operations Officer",
        },
        {
            id: 4,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/C-Franco.jpg",
            name: "Claudia Franco",
            job_position: "Chief Legal Officer",
        },
        {
            id: 5,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/C-De+Saro.jpg",
            name: "Carlos De Saro",
            job_position: "Chief Commercial Officer",
        },
        {
            id: 6,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/L-Gonzalez.jpg",
            name: "María González",
            job_position: "Chief Title Officer",
        },
        {
            id: 7,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/C-Watanabe.jpg",
            name: "Carlos Watanabe",
            job_position: "Chief Commercial Officer",
        },
        {
            id: 8,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/Retrato+CGPM+Guia-10.jpg",
            name: "Carlos Puebla",
            job_position: "Chief People Officer",
        },
        {
            id: 9,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/T-Cota.jpg",
            name: "Tito Cota",
            job_position: "Chief Marketing Officer",
        },
        {
            id: 10,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/A-Alejo.jpg",
            name: "Antonio Alejo",
            job_position: "Chief Financial Officer",
        },
        {
            id: 11,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/consejo/I-Gutierrez.jpg",
            name: "Iván Gutiérrez",
            job_position: "Chief Listing Officer",
        },
        {
            id: 12,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/pau-4.jpg",
            name: "Pau Utrilla",
            job_position: "Chief Sales Officer",
        },
        {
            id: 13,
            image: "https://media.grupoguia.mx/assets/codigo-conducta/Jessica+Fabila-8.jpg",
            name: "Jessica Fabila",
            job_position: "Chief Sales Officer",
        },
    ];

    const [idx, setIdx] = useState(0);
    const [data, setData] = useState(0, 5);

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    useEffect(() => {
        if (carouselData.length > 0) {
            if (isGreaterThanMd) {
                setData(carouselData.slice(idx, idx + 5));
            } else {
                setData(carouselData.slice(idx, idx + 1));
            }
        }
    }, [idx]);

    useEffect(() => {
        if (isGreaterThanMd) {
            setData(carouselData.slice(0, 5));
        } else {
            setData(carouselData.slice(0, 1));
        }
    }, [isGreaterThanMd]);

    const handleNext = () => {
        if (idx < carouselData.length - 1) {
            setIdx(idx + 1);
        } else {
            setIdx(0);
        }
    };

    const handlePrev = () => {
        if (idx > 0) {
            setIdx(idx - 1);
        } else {
            setIdx(carouselData.length - 1);
        }
    };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.download = "Formulario de denuncia.docx";
        link.href = "https://media.grupoguia.mx/assets/codigo-conducta/Formulario+de+denuncia.docx";
        link.click();
    };

    return (
        <>
            <Head>
                <title>Estándares de Conducta | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/codigo-conducta" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/codigo-conducta"
                    hrefLang="es-mx"
                />
            </Head>
            <Header />
            <Container maxWidth={{ base: "8xl", md: "7xl" }} pt={16} mx="auto">
                <Flex direction={{ base: "column", md: "row" }}>
                    <Sidebar selected="estandares" />
                    <Box
                        pt={10}
                        pb={20}
                        minHeight="100vh"
                        mt={16}
                        maxW={{ base: "100%", md: "80%" }}
                    >
                        <Stack>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                textAlign="center"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                ANUNCIO E INTRODUCCIÓN
                            </Text>
                        </Stack>
                        <Stack>
                            {data ? (
                                <Flex justifyContent="center" alignItems="center">
                                    <Button
                                        onClick={handlePrev}
                                        border="1px"
                                        borderColor="#D3D3D3"
                                        p={2}
                                        borderRadius="full"
                                        color="black"
                                        bg="white"
                                        fontWeight="300"
                                        right={-4}
                                        disabled={idx === 0}
                                    >
                                        {"<"}
                                    </Button>
                                    <Grid
                                        templateColumns={{
                                            base: "repeat(1, 1fr)",
                                            md: "repeat(5, 1fr)",
                                        }}
                                        gap={4}
                                    >
                                        {data?.map((item) => (
                                            <CardItem key={item.id} item={item} />
                                        ))}
                                    </Grid>
                                    <Button
                                        onClick={handleNext}
                                        border="1px"
                                        borderColor="#D3D3D3"
                                        p={2}
                                        borderRadius="full"
                                        color="black"
                                        bg="white"
                                        fontWeight="300"
                                        left={-4}
                                        disabled={
                                            idx === carouselData.length - 1 ||
                                            data.length + idx === carouselData.length
                                        }
                                    >
                                        {">"}
                                    </Button>
                                </Flex>
                            ) : (
                                <Spinner />
                            )}
                        </Stack>
                        <Stack my={4} mt={8}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                textAlign="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                Anuncio del Consejo Directivo
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Somos los responsables en GRUPO GUIA de fijar las políticas,
                                lineamientos y en general reglas aplicables para la forma de
                                relacionarnos.
                                <br />
                                Nuestro compromiso es informar con claridad a cualquier persona que
                                guarde relación con GRUPO GUIA, los estándares de conducta aceptados
                                y permitidos. En sentido opuesto, aquellas conductas que se
                                encuentran estrictamente prohibidas.
                                <br /> <br />
                                Este documento orienta también a cualquier persona que reciba un
                                trato contrario a lo mencionado en estos estándares de conducta
                                sobre la forma en que puede iniciar una denuncia interna.
                                <br /> <br />
                                <strong>GRUPO GUIA</strong> respeta el principio a la dignidad
                                humana, reprobando cualquier conducta que no tenga los estándares
                                mínimos que representen los valores de la compañía.
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack pr={{ base: 0, md: 8 }}>
                                    <Text
                                        fontSize={{ md: "2xl", base: "xl" }}
                                        textAlign="start"
                                        mb="8"
                                        color="accent.500"
                                        fontWeight="700"
                                    >
                                        Definiciones
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>Objetivo</strong>
                                        <br />
                                        Establecer los estándares de conducta permitidos en{" "}
                                        <strong>GRUPO GUIA</strong>, para prevenir, investigar e
                                        identificar los factores de riesgo, así como para promover
                                        un entorno favorable en las relaciones interpersonales.
                                        <br /> <br />
                                        <strong>Campo de aplicación</strong>
                                        <br />
                                        Este documento es de observancia obligatoria, rige para
                                        todas las ciudades en que se encuentre{" "}
                                        <strong>GRUPO GUIA</strong> en operación, de acuerdo con lo
                                        siguiente:
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <span style={{ fontWeight: "bold", marginRight: "5px" }}>
                                            a.{" "}
                                        </span>
                                        Para las Para las relaciones interpersonales que se den
                                        entre empleados, comisionistas o promotores autorizados de{" "}
                                        <strong>GRUPO GUIA</strong>, en forma interna dentro de la
                                        organización.
                                        <br /> <br />
                                        <span style={{ fontWeight: "bold", marginRight: "5px" }}>
                                            b.{" "}
                                        </span>
                                        Para las relaciones interpersonales que se den entre
                                        personas externas de la organización relación de carácter
                                        comercial y/o contractual con <strong>GRUPO GUIA</strong>,
                                        (así como sus empleados, proveedores, contratistas,
                                        prestadores de servicio, comisionistas y en general personas
                                        con las que tengan relación) con personal interno de{" "}
                                        <strong>GRUPO GUIA</strong>.
                                        <br /> <br />
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/1.svg"
                                        maxW="100%"
                                        h="auto"
                                        w="100%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                pt={4}
                            >
                                Se entiende en forma enunciativa más no limitativa la mención de ser
                                personal interno, empleados, comisionistas o promotores autorizados.
                                En general se refiere a la persona física que realice una prestación
                                de servicios, trabajo o actividad comercial para GRUPO GUIA o bien
                                actúe en nombre y representación de ésta.
                                <br /> <br />
                                Los estándares de conducta no pueden abordar cada situación posible,
                                por lo que se solicita utilizar el sentido común y buen juicio,
                                haciendo preguntas y acercándose a los canales de comunicación
                                establecidos en este documento para cualquier duda.
                                <br /> <br />
                                <strong
                                    style={{
                                        fontWeight: "bold",
                                        marginRight: "5px",
                                        textDecoration: "underline",
                                    }}
                                >
                                    No observar este documento o atentar en contra de lo dispuesto
                                    implicará una sanción.
                                </strong>
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Con la intención de orientar a cualquier persona, se hace una
                                definición de las conductas indebidas clasificadas como graves y que
                                de ser identificadas traerán una sanción inmediata para quien las
                                realice, con independencia de cualquier acción legal que pudiera ser
                                ejercida por quien resulte tener derecho.
                            </Text>
                            <List.Root
                                as="ol"
                                gap={3}
                                listStyle="lower-alpha"
                                fontWeight={800}
                                ml={4}
                            >
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Acoso psicológico:</strong> Aquellos actos que dañan
                                        la estabilidad psicológica, la personalidad, la dignidad o
                                        integridad de una persona. Consiste intimidación sistemática
                                        y persistente, tales como: descrédito, insultos,
                                        humillaciones, devaluación, marginación, indiferencia,
                                        comparaciones destructivas, rechazo, restricción a la
                                        autodeterminación y amenazas, las cuales llevan a una
                                        persona a la depresión, al aislamiento, a la pérdida de su
                                        autoestima.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Hostigamiento:</strong> : El ejercicio de poder en
                                        una relación de subordinación real de la víctima frente al
                                        agresor en el ámbito laboral, que se verbales, físicas o
                                        ambas.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Malos tratos:</strong> Aquellos actos consistentes
                                        en insultos, burlas, humillaciones y/o ridiculizaciones,
                                        realizados de manera continua y persistente y/o en
                                        diferentes ocasiones).
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Hostigamiento sexual:</strong> Asediar u hostigar
                                        con fines de naturaleza sexual a una persona valiéndose de
                                        su posición jerárquica o de poder, implicando subordinación
                                        de la víctima. Le informamos esta acción además se
                                        tipificada como delito en legislación mexicana.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Acoso sexual:</strong> El acoso sexual es un
                                        comportamiento verbal o físico de naturaleza sexual que
                                        tiene como objetivo o efecto atentar contra la una persona.
                                        Le informamos esta acción además se encuentra tipificada
                                        como delito en legislación mexicana.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Chantaje sexual:</strong> Es el que se produce
                                        verbal, no verbal o físico de naturaleza sexual u otro
                                        comportamiento basado en el sexo, que afecta las personas,
                                        el cual es no deseado, irrazonable y ofensivo para el
                                        destinatario. Este tipo de acto tiene la intención de
                                        controlar a una persona y/o intercambiar privilegios en sus
                                        actividades.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Violencia contra la mujer:</strong> Violencia contra
                                        las mujeres en general. Cualquier acción o conducta basada
                                        por razón del género que cause consecuencias físicas o
                                        psicológicas a una o varias mujeres. Exclusión sin
                                        justificación sobre determinadas actividades por razón del
                                        género. Comentarios generalizados que sexualicen, denigren,
                                        minimicen y excluyan a las mujeres en general por razón de
                                        su género.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Discriminación por orientación sexual:</strong>{" "}
                                        Cualquier acto verbal, no verbal o físico que tenga por
                                        objeto excluir a cualquier persona motivada por orientación
                                        sexual. Este tipo de discriminación atenta contra la
                                        dignidad y puede generar consecuencias físicas y/o
                                        psicológicas en la persona. Comentarios generalizados que
                                        denigren, minimicen, busquen ridiculizar o excluir a
                                        cualquier persona con motivo de su orientación sexual ,
                                        atentando contra su dignidad, se consideran
                                        discriminatorios.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Conducta indebida grave:</strong> Cualquier
                                        actividad que podría causar un daño de índole legal,
                                        financiero o en la reputación para la compañía. La ilegal o
                                        un incumplimiento grave de políticas o principios de GRUPO
                                        GUIA.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        <strong>Discriminación:</strong> Trato injusto y desigual
                                        hacia una persona o grupo de personas, basado en prejuicios,
                                        estereotipos o estigmas. Este trato desventajas o restringir
                                        derechos a las personas que lo reciben.
                                    </Text>
                                </List.Item>
                            </List.Root>
                        </Stack>
                        <Stack mt={12}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                textAlign="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                Responsabilidad
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Se deberá leer este documento, comprenderlo y llevarlo a la
                                práctica. Debemos actuar como orientadores frente a cualquier
                                persona.
                                <br /> <br />
                                Cuando exista un conflicto entre una ley o reglamento legislativo
                                contra estos estándares de conducta, prevalecerá la legislación.
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                borderColor="#E2E2E2"
                                borderWidth={1}
                                py={10}
                                px={10}
                                borderRadius="21px"
                            >
                                <Stack pr={{ base: 0, md: 6 }}>
                                    <Text
                                        fontSize={{ md: "2xl", base: "xl" }}
                                        textAlign="start"
                                        mb="8"
                                        color="accent.500"
                                        fontWeight="700"
                                    >
                                        Rol Especial de Gerentes y Directores
                                    </Text>
                                    <Text
                                        fontSize={{ md: "md", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Si usted supervisa personas, está obligado a:
                                    </Text>
                                    <List.Root
                                        gap={3}
                                        fontWeight={800}
                                        pl={{ base: 4, md: 0 }}
                                        ml={4}
                                    >
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Servir como modelo de los valores de{" "}
                                                <strong>GRUPO GUIA</strong> en su actuar dentro del
                                                ejercicio de sus funciones. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Comprender y seguir nuestros estándares de conducta,
                                                las políticas de la compañía y la ley en lo que
                                                respecta a sus funciones. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Escuchar a la persona que en primera instancia se
                                                acerque a Informar sobre conductas contrarias a
                                                nuestros estándares y mencionarle sobre la
                                                existencia de este documento. De ser necesario
                                                explicar los procedimientos que aquí se establecen. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Presentar la denuncia interna una vez que tenga
                                                conocimiento de la situación, de conformidad a los
                                                procedimientos establecidos, debiendo guardar la
                                                identidad de la persona afectada cuando así sea
                                                adecuado, pero proporcionando todos los datos
                                                requeridos para iniciar una investigación correcta. 
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/2.svg"
                                        maxW="100%"
                                        h="auto"
                                        w="100%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/3.svg"
                                        maxW="100%"
                                        h="auto"
                                        w="100%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack pl={{ base: 0, md: 8 }}>
                                    <Text
                                        fontSize={{ md: "2xl", base: "xl" }}
                                        textAlign="start"
                                        mb="8"
                                        color="accent.500"
                                        fontWeight="700"
                                    >
                                        ¡Denuncia!
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>¡Tu voz importa!</strong>
                                        <br />
                                        Para identificar aquellas conductas contrarias a nuestros
                                        estándares, necesitamos de tu ayuda siguiendo el proceso que
                                        se menciona a continuación.
                                        <br /> <br />
                                        Cualquier conducta inapropiada debe ser reportada. No
                                        reportarla implica que la persona que la cometa pueda
                                        reincidir ya sea con la misma persona o con terceros. Es un
                                        acto de seguridad para todos.
                                        <br /> <br />
                                        Tener conocimiento de actos que contravengan los estándares
                                        de conducta y no denunciar implica una tolerancia o
                                        complicidad. Mantenemos una postura de cero tolerancias.
                                        <br /> <br />
                                        Basta con tener conocimiento para tener la obligación de
                                        iniciar una denuncia interna, en los canales establecidos.
                                        <br /> <br />
                                        Cuidamos la presunción de inocencia y funcionamos con
                                        objetividad e imparcialidad. Si eres hombre, mujer o el
                                        género con el que te sientas identificado, es indistinto
                                        para nosotros, la denuncia tiene el mismo peso e
                                        importancia.
                                    </Text>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Box borderColor="#E2E2E2" borderWidth={1} borderRadius="lg" p={10}>
                                <Flex
                                    justifyContent="space-between"
                                    direction={{ base: "column", md: "row" }}
                                >
                                    <Stack>
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Recibiste o tienes conocimiento de una conducta
                                            contraria a nuestros estándares éticos. Pregúntate:
                                        </Text>
                                        <List.Root gap={0} fontWeight={800} ml={4}>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Esta conducta es contraria a los valores de
                                                    GRUPO GUIA o a lo establecido en este documento?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Es contraria a la ley?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Contradice o es incoherente con las políticas
                                                    de GRUPO GUIA?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Estás seguro representa riesgos para la
                                                    compañía o para una persona que tenga relación
                                                    con GRUPO GUIA?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Cuentas con la información suficiente para
                                                    tomar una decisión adecuada?
                                                </Text>
                                            </List.Item>
                                        </List.Root>
                                        <Box px={4} py={2} bg="#C0E7FA" mt={2} w="fit-content">
                                            <Text
                                                fontSize={{ md: "md", base: "sm" }}
                                                textAlign="start"
                                                color="accent.500"
                                                fontWeight={400}
                                            >
                                                Si la respuesta a cualquiera de esas preguntas es
                                                SI, procede con tu denuncia.
                                            </Text>
                                        </Box>
                                    </Stack>
                                    <Stack ml={{ base: 0, md: 8 }} alignSelf="center">
                                        <Image
                                            src="https://media.grupoguia.mx/assets/codigo-conducta/4.svg"
                                            maxW="100%"
                                            h="auto"
                                            w="100%"
                                            alt="image"
                                            objectFit="contain"
                                        />
                                    </Stack>
                                </Flex>
                            </Box>
                        </Stack>
                        <Stack mt={12}>
                            <Text
                                fontSize={{ md: "lg", base: "md" }}
                                textAlign="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                Si no estás seguro a la respuesta de estas preguntas, por favor
                                reporta: 
                            </Text>
                            <List.Root gap={0} fontWeight={800} pl={4} ml={4}>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        En forma anónima a través de nuestro canal de denuncias:{" "}
                                        <a
                                            href="mailto:tuvozimporta@grupoguia.mx"
                                            style={{
                                                textDecoration: "underline",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            tuvozimporta@grupoguia.mx
                                        </a>{" "}
                                        (correo electrónico).
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        A través de los buzones que se encuentran instalados dentro
                                        del Departamento Jurídico y fuera de la oficina del Director
                                        de People Experience.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontWeight={400} color="accent.500">
                                        Si tienes una relación contractual con GRUPO GUIA y estás
                                        recibiendo o detectas una conducta indebida o contraria a
                                        nuestros estándares de conducta por parte de alguna persona
                                        que actúa en representación de GRUPO GUIA, por favor reporta
                                        al correo electrónico:{" "}
                                        <a
                                            href="mailto:tuvozimporta@grupoguia.mx"
                                            style={{
                                                textDecoration: "underline",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            tuvozimporta@grupoguia.mx
                                        </a>
                                    </Text>
                                </List.Item>
                            </List.Root>
                            <Box px={4} py={2} bg="#C0E7FA" mt={4} w="fit-content">
                                <Text
                                    fontSize={{ md: "md", base: "sm" }}
                                    textAlign="start"
                                    color="accent.500"
                                    fontWeight={400}
                                >
                                    Te recordamos la denuncia no tiene respuesta inmediata. Si el
                                    factor tiempo implica un posible daño a una persona o{" "}
                                    <strong>GRUPO GUIA</strong>, te pedimos te comuniques en forma
                                    directa a Dirección Jurídica o Dirección de People Experience
                                    quienes iniciarán de inmediato con las acciones necesarias.
                                </Text>
                            </Box>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/5.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack pl={{ base: 0, md: 8 }}>
                                    <Text
                                        fontSize={{ md: "2xl", base: "xl" }}
                                        textAlign="start"
                                        mb="8"
                                        color="accent.500"
                                        fontWeight="700"
                                    >
                                        ¿Cómo reporto?
                                    </Text>
                                    <Text
                                        fontSize={{ md: "md", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Tenemos para ti distintos canales en los que podrás iniciar
                                        tu denuncia interna, ya sea en forma anónima o no.
                                        <br />
                                        <br />
                                        <Box ml={4}>
                                            Medios anónimos
                                            <br /> <br />
                                            <Flex alignItems="center">
                                                <Text mr={2} ml={-2}>
                                                    &middot;
                                                </Text>
                                                <Text
                                                    fontSize={{ md: "md", base: "sm" }}
                                                    textAlign="start"
                                                    color="accent.500"
                                                    fontWeight={400}
                                                >
                                                    Buzón de denuncia anónima: Dentro de las
                                                    oficinas centrales de GRUPO GUIA ubicadas en
                                                    Avenida Pablo Neruda 2813, Colonia Providencia
                                                    4ta Sección, Ciudad de Guadalajara, Estado de
                                                    Jalisco, CP 44639 se encuentran instalados dos
                                                    buzones en los que podrás depositar tu reporte
                                                    por escrito.
                                                </Text>
                                            </Flex>
                                            <br /> <br />
                                            Estos buzones se encuentran instalados dentro del
                                            Departamento Jurídico y a la entrada de la oficina del
                                            Director de People Experience.
                                            <br /> <br />
                                            Podrás presentar un escrito libre o bien descargar el
                                            formato directamente en el botón ¨Descargar formato¨
                                            <br />
                                            <Button
                                                bg="accent.500"
                                                color="white"
                                                borderRadius="md"
                                                onClick={handleDownload}
                                                px={4}
                                                fontWeight="semibold"
                                            >
                                                Descargar formato
                                            </Button>
                                            <br /> <br />
                                            Nuestros buzones tienen acceso restringido y se
                                            encuentran protegidos bajo llave.
                                            <Flex alignItems="center">
                                                <Text mr={2} ml={-2}>
                                                    &middot;
                                                </Text>
                                                <Text
                                                    fontSize={{ md: "md", base: "sm" }}
                                                    textAlign="start"
                                                    color="accent.500"
                                                    fontWeight={400}
                                                >
                                                    Correo de denuncias anónimas: A través del
                                                    correo electrónico{" "}
                                                    <a
                                                        href="mailto:tuvozimporta@grupoguia.mx"
                                                        style={{
                                                            textDecoration: "underline",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        tuvozimporta@grupoguia.mx
                                                    </a>{" "}
                                                    recibiremos en forma anónima tu reporte. A
                                                    través del mismo medio estaremos en contacto
                                                    contigo.
                                                </Text>
                                            </Flex>
                                        </Box>
                                    </Text>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Tu reporte, en cualquiera de los dos medios, deberán
                                        contener por lo menos la siguiente información: 
                                    </Text>
                                    <Flex>
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                            mr={4}
                                        >
                                            1.
                                        </Text>
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Relato de los hechos con tus palabras: Circunstancias de
                                            modo, tiempo y lugar (qué, quién, cómo, cuándo). Aquí
                                            algunas preguntas que te podrán ayudar a desarrollar tu
                                            reporte.
                                        </Text>
                                    </Flex>
                                    <List.Root gap={0} fontWeight={800} pl={8} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Qué conducta o conductas quieres reportar?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Qué día o aproximadamente en que tiempo sucedió?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Es algo que sucedió una sola vez o se ha realizado
                                                en distintas etapas?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Es algo que esté sucediendo en forma repetitiva o
                                                constante?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Quién o quienes están realizando estas conductas?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Existen o tienes sospecha de cómplices de estas
                                                conductas?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿En dónde sucedieron los hechos? Ayúdanos a
                                                identificar en qué lugar.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Consideras existe alguna persona en peligro físico
                                                o emocional de no intervenir en esta situación? Por
                                                favor di quién.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                ¿Hay alguien que pueda testificar lo que reportas?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Lo que reportas, ¿te consta o te enteraste por
                                                alguna persona? A través de quién te enteraste.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                    <Flex>
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                            mr={4}
                                        >
                                            2.
                                        </Text>
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Por favor cualquier prueba que tengas sobre tu reporte
                                            nos funciona para realizar una investigación adecuada.
                                        </Text>
                                    </Flex>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/6.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/7.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "md", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        pb={2}
                                    >
                                        Formas de reporte no anónimas
                                    </Text>
                                    <Text
                                        fontSize={{ md: "md", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Si utilizas este medio es importante conozcas tu reporte se
                                        encuentra sujeto a confidencialidad por lo que al utilizar
                                        los canales adecuados estarás garantizando se mantenga tu
                                        identidad protegida y la información se comparta solamente
                                        con aquellos asignados dentro del proceso, todos con
                                        obligación de confidencialidad.
                                        <br />
                                        <br />
                                        Tu identidad solamente será revelada en caso de ser
                                        estrictamente necesario a criterio del equipo investigador
                                        designado por el Comité de Ética (en este supuesto te será
                                        informado en forma previa) o por disposición legal.
                                    </Text>
                                    <List.Root gap={4} fontWeight={800} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Si quieres reportar puedes escribir o solicitar una
                                                cita en forma directa al Director de People
                                                Experience: David Vázquez{" "}
                                                <a
                                                    href="mailto:dvazquez@grupoguia.mx"
                                                    style={{
                                                        textDecoration: "underline",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    dvazquez@grupoguia.mx
                                                </a>{" "}
                                                y/o al Director Jurídico: Claudia Franco{" "}
                                                <a
                                                    href="mailto:cfranco@grupoguia.mx"
                                                    style={{
                                                        textDecoration: "underline",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    cfranco@grupoguia.mx
                                                </a>
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Si tienes duda o quieres llevar un proceso
                                                acompañado, puedes optar por hablar con el Gerente o
                                                Director de tu área quien tendrá la obligación de
                                                orientarte, acompañarte o incluso reportar los
                                                hechos. Podrá omitir tu identidad cuándo tú así lo
                                                solicites. Cuando nos proporcionen tus datos
                                                implicará que te contactemos en forma directa cuando
                                                sea necesario. Tu Director o Gerente estará obligado
                                                a proporcionarnos tu identidad, aún cuando solicites
                                                lo contrario, cuando se encuentre en riesgo tu
                                                integridad física o emocional.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                A través del buzón de denuncia anónima o correo de
                                                denuncia anónima:{" "}
                                                <a
                                                    href="mailto:tuvozimporta@grupoguia.mx"
                                                    style={{
                                                        textDecoration: "underline",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    tuvozimporta@grupoguia.mx
                                                </a>
                                                , siguiendo las recomendaciones y proporcionando el
                                                correo electrónico y/o número telefónico al que
                                                podemos contactarte.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} bg="#BEE4F6" px={6} py={4}>
                            <Text
                                fontSize={{ md: "md", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Si estás por realizar una conducta y tienes duda sobre si es
                                contraria a los estándares de conducta de GRUPO GUIA o contraria a
                                la ley, por favor detente y pregunta en cualquiera de los canales
                                establecidos (si eliges forma anónima considera necesitamos los
                                datos sobre dónde podemos darte respuesta).
                                <br />
                                <br />
                                Si existe alguien que te esté dando una instrucción o intimidando
                                para realices una conducta indebida, reportarlo en cualquiera de
                                nuestros canales siendo claro en el nombre de la persona que te está
                                exigiendo lo hagas.
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        pb={2}
                                    >
                                        Quién puede denunciar
                                    </Text>
                                    <Text
                                        fontSize={{ md: "md", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={6}
                                    >
                                        Cualquier persona que tenga conocimiento de actos contrarios
                                        a los estándares de conducta aceptados por{" "}
                                        <strong>GRUPO GUIA</strong> o la legislación y que sean
                                        realizados por o en contra de una persona que mantenga
                                        relación con <strong>GRUPO GUIA.</strong>
                                        <br />
                                        <br />
                                        Nuestro canal de denuncias no funciona para situaciones en
                                        las que el afectado las reciba por personas ajenas a{" "}
                                        <strong>GRUPO GUIA</strong>, esto es, personas con las que{" "}
                                        <strong>GRUPO GUIA</strong> no tiene relación comercial y/o
                                        contractual. En este supuesto la presunta víctima deberá
                                        actuar en forma directa con la autoridad competente. 
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/8.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                pb={2}
                            >
                                Actuaremos
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Para actuar necesitamos de tu denuncia a través de los canales
                                establecidos en este documento. Sin embargo, si tú conoces cualquier
                                situación en la que una persona deba o sospeches deba denunciar, te
                                pedimos le informes cuáles son los canales adecuados y al mismo
                                tiempo levantes la denuncia por ti mismo que nos permita iniciar la
                                investigación. 
                                <br />
                                <br />
                                Recuerda que no denunciar implica que la persona que realizó o
                                realiza la conducta inapropiada podrá continuar haciéndolo contra la
                                misma persona o contra terceros. 
                                <br />
                                <br />
                                Tener conocimiento de una conducta inapropiada y no denunciar podrá
                                traer sanciones en contra de quien oculte, manipule información o no
                                coopere con la investigación. Esta sanción será determinada por el
                                Comité de Ética que podrá llegar hasta la terminación de la relación
                                contractual. 
                                <br />
                                <br />
                                Si tú eres directamente el afectado y no te sientes preparado o
                                preparada para denunciar, no recibirás una sanción, entendemos tu
                                proceso. Los canales están a tu disposición buscando velar por tus
                                derechos y apoyarte. Te sugerimos ampliamente utilizar los canales
                                anónimos que nos permitan en una primera instancia iniciar una
                                investigación. 
                                <br />
                                <br />
                                Entendemos si eres el afectado en forma directa que puedas tener
                                especial confianza hacia una persona en particular dentro de la
                                organización. Toma en cuenta que esta persona estará obligada a
                                iniciar la denuncia que permita iniciar una investigación. 
                                <br />
                                <br />
                                Las personas involucradas en las denuncias mantienen obligaciones de
                                confidencialidad que no necesariamente podrás exigir a las personas
                                a quien tú acudas si optas por no realizar una denuncia en los
                                canales mencionados. Mantenemos un proceso y a las personas con los
                                conocimientos especializados o posición adecuada dentro de la
                                compañía para poder ayudarte.
                                <br />
                                <br />
                                En cualquier caso es importante hacer de tu conocimiento existen
                                supuestos en los que la legislación obliga a romper la privacidad y
                                confidencialidad. En principio cualquier acto que implique la
                                perdida de salud, integridad física o la vida de una persona. 
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12} bg="#BEE4F6" px={6} py={4}>
                            <Text
                                fontSize={{ md: "md", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Si informas una inquietud, puedes confiar en que la tomaremos con
                                seriedad. Ten por seguro que tu denuncia se investigará a
                                profundidad y, finalmente, se tomará la medida adecuada.
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12} gap={6}>
                            <Box bg="#F4F4F4" px={6} py={4} borderRadius="10px">
                                <Flex
                                    direction={{ base: "column", md: "row" }}
                                    justify="space-between"
                                >
                                    <Stack alignSelf="center" mr={{ base: 0, md: 6 }}>
                                        <Image
                                            src="https://media.grupoguia.mx/assets/codigo-conducta/10-1.svg"
                                            maxW="100px"
                                            h="auto"
                                            w="80px"
                                            alt="image"
                                            objectFit="contain"
                                        />
                                    </Stack>
                                    <Stack>
                                        <Text
                                            fontSize={{ md: "xl", base: "md" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={600}
                                        >
                                            Tolerancia cero a las amenazas o represalias
                                        </Text>
                                        <Text
                                            fontSize={{ md: "md", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Si buscas consejo, asesoría o hacer una denuncia estás
                                            haciendo lo correcto y se te protegerá. GRUPO GUIA
                                            mantiene tolerancia cero a las represalias. Amenazar,
                                            acosar o tomar represalias contra la persona que de
                                            buena fe presenta una denuncia o participa en una
                                            investigación se encuentra estrictamente prohibido.
                                            Cualquier persona que realice represalias o actividades
                                            intimidatorias se enfrentará a medidas disciplinarias,
                                            que incluyen hasta la terminación de la relación
                                            contractual. 
                                        </Text>
                                    </Stack>
                                </Flex>
                            </Box>
                            <Box bg="#F4F4F4" px={6} py={4} borderRadius="10px">
                                <Flex
                                    direction={{ base: "column", md: "row" }}
                                    justify="space-between"
                                >
                                    <Stack alignSelf="center" mr={{ base: 0, md: 6 }}>
                                        <Image
                                            src="https://media.grupoguia.mx/assets/codigo-conducta/10-2.svg"
                                            maxW="100px"
                                            h="auto"
                                            w="80px"
                                            alt="image"
                                            objectFit="contain"
                                        />
                                    </Stack>
                                    <Stack>
                                        <Text
                                            fontSize={{ md: "xl", base: "md" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={600}
                                        >
                                            Proceso de investigación
                                        </Text>
                                        <List.Root gap={4} fontWeight={800} pl={4} pb={2} ml={4}>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    <strong>Paso 1:</strong> Se recibe la denuncia.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    <strong>Paso 2:</strong> Se verifica la denuncia
                                                    cuando se mencione el nombre de un denunciante
                                                    en particular.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    <strong>Paso 3:</strong> Se reúne el Comité de
                                                    Ética para conocer la denuncia y se elabora un
                                                    plan de acción específico orientado a la
                                                    investigación de los hechos. Este plan podrá
                                                    incluir crear un equipo con personas en
                                                    particular cuya intervención sea benéfica.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    <strong>Paso 4:</strong> Terminada la
                                                    investigación el Comité de Ética medida
                                                    adecuada.
                                                </Text>
                                            </List.Item>
                                        </List.Root>
                                    </Stack>
                                </Flex>
                            </Box>
                            <Box bg="#F4F4F4" px={6} py={4} borderRadius="10px">
                                <Flex
                                    direction={{ base: "column", md: "row" }}
                                    justify="space-between"
                                >
                                    <Stack alignSelf="center" mr={{ base: 0, md: 6 }}>
                                        <Image
                                            src="https://media.grupoguia.mx/assets/codigo-conducta/10-3.svg"
                                            maxW="100px"
                                            h="auto"
                                            w="80px"
                                            alt="image"
                                            objectFit="contain"
                                        />
                                    </Stack>
                                    <Stack>
                                        <Text
                                            fontSize={{ md: "xl", base: "md" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={600}
                                        >
                                            Comité de Ética
                                        </Text>
                                        <Text
                                            fontSize={{ md: "md", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            En todas las denuncias se dará conocimiento al Comité de
                                            Ética quien estará integrando por personas cuya
                                            identidad se protege. No en todas las investigaciones
                                            podrán participar las mismas personas, dependerá del
                                            tipo de conducta inapropiada. Cuando exista conflictos
                                            de intereses con algún miembro del Comité de Etica, será
                                            excluido de la investigación.
                                        </Text>
                                    </Stack>
                                </Flex>
                            </Box>
                            <Box bg="#F4F4F4" px={6} py={4} borderRadius="10px">
                                <Flex
                                    direction={{ base: "column", md: "row" }}
                                    justify="space-between"
                                >
                                    <Stack alignSelf="center" mr={{ base: 0, md: 6 }}>
                                        <Image
                                            src="https://media.grupoguia.mx/assets/codigo-conducta/10-4.svg"
                                            maxW="100px"
                                            h="auto"
                                            w="80px"
                                            alt="image"
                                            objectFit="contain"
                                        />
                                    </Stack>
                                    <Stack>
                                        <Text
                                            fontSize={{ md: "xl", base: "md" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={600}
                                        >
                                            Presunción de inocencia
                                        </Text>
                                        <Text
                                            fontSize={{ md: "md", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Ante cualquier denuncia recibida se buscará la
                                            imparcialidad y objetividad. Está estrictamente
                                            prohibido por parte de cualquier persona que participe
                                            en la investigación emitir juicios de valor y divulgar o
                                            compartir información sin causa justificada. 
                                        </Text>
                                    </Stack>
                                </Flex>
                            </Box>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                pb={2}
                            >
                                Respeto
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Las relaciones interpersonales en <strong>GRUPO GUIA</strong> deben
                                ser dirigidas con respeto. El respeto debe ser proporcionado a cada
                                una de las personas con las que interactúes con motivo de tus
                                funciones. El mismo derecho tienes de recibir respeto.  
                                <br />
                                <br />
                                En la organización no hay lugar al acoso o discriminación, en
                                ninguna de sus formas. Tienes que tratar siempre a tus colegas con
                                dignidad y respeto. 
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                    >
                                        ESPACIOS LIBRES DE DISCRIMINACIÓN
                                    </Text>
                                    <Text
                                        fontSize={{ md: "md", base: "md" }}
                                        textAlign="md"
                                        color="accent.500"
                                        fontWeight={600}
                                        pb={2}
                                        textDecoration="underline"
                                    >
                                        Detectar la discriminación
                                    </Text>
                                    <Text
                                        fontSize={{ md: "md", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={6}
                                    >
                                        La discriminación atenta contra los derechos humanos y se
                                        encuentra definida como trato injusto y desigual hacia una
                                        persona o grupo de personas, basado en prejuicios,
                                        estereotipos o estigmas. Este trato puede generar
                                        desventajas o restringir derechos a las personas que lo
                                        reciben. 
                                        <br />
                                        <br />
                                        Cualquier conducta discriminatoria oral, escrita o en hechos
                                        que denigre, excluya, aísle o atente contra la dignidad de
                                        una persona debido a su raza, religión, color de piel,
                                        imagen física, identidad o expresión de género, orientación
                                        sexual, edad, discapacidad, nacionalidad, ciudadanía, linaje
                                        o cualquier otra identificada como vulnerable por la
                                        Comisión de Derechos Humanos se encuentra estrictamente
                                        prohibida. 
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/non-discrimination.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} bg="#F5F5F5" borderRadius="md" px={10} py={6}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/leader.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                    >
                                        Si tú eres Líder de Área:
                                    </Text>
                                    <List.Root gap={4} fontWeight={800} pl={4} pb={2} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Fomenta un ambiente de trabajo inclusivo y detén
                                                cualquier acción que pueda considerarse
                                                discriminatoria hablando en forma directa con la
                                                persona que la realice o pretenda realizarla.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Muéstrate disponible para los integrantes de tu
                                                equipo que busquen conversar sobre estos temas.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Denuncia toda conducta indebida
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                No tomes represalias contra los integrantes de tu
                                                equipo que comiencen una denuncia.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "md", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                mr={6}
                            >
                                La legislación en materia de derechos humanos reconoce especial
                                vulneración en distintos sectores o grupos de personas a nivel
                                mundial.
                                <br />
                                Aquí algunos de ellos: 
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                mt={8}
                                textDecoration="underline"
                            >
                                Mujeres
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Las conductas aceptadas en la organización hacia las mujeres buscan
                                garantizar espacios libres de violencia, en cualquiera de sus
                                formas. Se debe evitar comunicación que implique denigrar,
                                sexualizar, aislar, excluir o vulnerar de cualquier forma a una o un
                                grupo de mujeres. 
                                <br />
                                <br />
                                Un trato de respeto hacia las mujeres es el esperado ya sea para
                                colaboradoras, prestadoras de servicio, clientes, comisionistas y en
                                general cualquier mujer que tenga presencia o relación con motivo de
                                la operación de <strong>GRUPO GUIA</strong>
                                . 
                            </Text>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack
                                    borderWidth={1}
                                    borderColor="#A3A3A3"
                                    borderRadius="md"
                                    px={10}
                                    py={6}
                                >
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Ejemplos de conductas inapropiadas hacia las mujeres:
                                    </Text>
                                    <List.Root gap={2} fontWeight={800} pl={4} pb={2} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Excluir a una mujer de una actividad, o asignarle
                                                pocas responsabilidades, por el hecho de ser mujer,
                                                sin razón justificada.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Chistes que puedan ser considerados machistas o
                                                misóginos.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Generar comentarios denigrantes, por el simple hecho
                                                de ser mujer.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Agresión física.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Agresión verbal.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Mensajes de texto ofensivos.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Miradas obscenas.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Exigirle acudir a lugares distintos al centro de
                                                trabajo, incluso para convivencia, cuando manifieste
                                                claramente su falta de interés.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        La violencia contra la mujer se caracteriza por ser
                                        sistemática y generalizada con el género femenino, por el
                                        simple hecho de ser mujer.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "35%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/womens.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                mt={8}
                                textDecoration="underline"
                            >
                                Comunidad LGBTIQ+
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                La comunidad LGBTIQ+ es considerada por la Comisión Nacional de los
                                Derechos Humanos (O sus siglas CNDH) un sector vulnerable de la
                                sociedad, siendo una comunidad que constantemente puede recibir
                                actos discriminatorios, incluyendo el ambiente laboral. 
                                <br />
                                <br />
                                Las personas de la comunidad tienen el derecho a no compartir frente
                                a los demás y en general no expresar su orientación sexual. Por el
                                contrario, tienen derecho a decir libremente su orientación sexual
                                sin recibir por parte de terceros comentarios o actos violentos y/o
                                discriminatorios. 
                                <br />
                                <br />
                                Entre los derechos humanos reconocidos se encuentran la libertad de
                                expresión, de asociación y de reunión pacífica, sin
                                discriminación.  
                                <br />
                                <br />
                            </Text>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack
                                    borderWidth={1}
                                    borderColor="#A3A3A3"
                                    borderRadius="md"
                                    px={10}
                                    py={6}
                                >
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Ejemplos de conductas inapropiadas hacia la comunidad:
                                    </Text>
                                    <List.Root gap={2} fontWeight={800} pl={4} pb={2} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Utilizar palabras que se refieran a la comunidad
                                                como un insulto.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Expresarse en favor de la homofobia.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Rechazo a cualquier persona de la comunidad.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Excluir a una persona de la comunidad motivada por
                                                este hecho.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Mensajes de texto ofensivo.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Chistes o comentarios que denigren a la comunidad.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/lgbt-community.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        mt={8}
                                        textDecoration="underline"
                                    >
                                        Personas indígenas
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Las personas indígenas mantienen una cultura propia. En
                                        GRUPO GUIA respetamos cualquier cultura indígena. 
                                        <br />
                                        <br />
                                        Reconocemos el derecho a su identidad, a defender sus
                                        tradiciones y su lengua. 
                                        <br />
                                        <br />
                                        Las personas de cualquier comunidad indígena tienen derecho
                                        a no ser discriminados con motivo de su origen. 
                                        <br />
                                        <br />
                                    </Text>
                                    <Stack
                                        borderWidth={1}
                                        borderColor="#A3A3A3"
                                        borderRadius="md"
                                        px={10}
                                        py={6}
                                    >
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Ejemplos de formas de apoyo a personas de comunidad
                                            indígena:
                                        </Text>
                                        <List.Root gap={2} fontWeight={800} pl={4} pb={2} ml={4}>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Respetar su identidad.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Incluirlos bajo un concepto de equidad.
                                                </Text>
                                            </List.Item>
                                        </List.Root>
                                    </Stack>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/native.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        mt={8}
                                        textDecoration="underline"
                                    >
                                        Niños y adolescentes
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Si bien los niños y adolescentes no son sujetos que puedan
                                        por sí mismos iniciar una relación jurídica o comercial con
                                        GRUPO GUIA, en ocasiones a través de sus tutores o curadores
                                        podemos obtener información sobre ellos, como cuando son
                                        propietarios, legatarios o herederos de una propiedad. 
                                        <br />
                                        <br />
                                        Debemos mantener especial atención al tratamiento de la
                                        información relacionada con niños y adolescentes, siendo
                                        estrictos en la protección de sus datos personales e
                                        identidad.  
                                        <br />
                                        <br />
                                        Cuando con motivo de los servicios de intermediación
                                        mantengamos contacto con niños y adolescentes deberá ser un
                                        trato digno de acuerdo a su edad, solicitando siempre a sus
                                        tutores o adultos responsables mantengan las medidas
                                        necesarias para mantener el cuidado adecuado de estos
                                        menores. 
                                        <br />
                                        <br />
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/childrens.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        mt={8}
                                        textDecoration="underline"
                                    >
                                        Personas con discapacidad <br />
                                        <br />
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        En <strong>GRUPO GUIA</strong> reconocemos los derechos
                                        humanos de las personas con discapacidad. Evitamos indagar
                                        en su historial clínico e historia de vida, salvo en lo
                                        estrictamente necesario por la persona y medida adecuada.
                                        Buscamos la inclusión bajo el concepto de equidad. 
                                    </Text>
                                    <Stack
                                        borderWidth={1}
                                        borderColor="#A3A3A3"
                                        borderRadius="md"
                                        px={10}
                                        py={6}
                                    >
                                        <Text
                                            fontSize={{ md: "lg", base: "sm" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={400}
                                            pb={2}
                                        >
                                            Ejemplos de formas en los que puedes apoyar a las
                                            personas con discapacidad:
                                        </Text>
                                        <List.Root gap={2} fontWeight={800} pl={4} pb={2} ml={4}>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Cuando así te sea solicitado apoya en lo que sea
                                                    específicamente solicitado.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Cuando sea evidente la necesidad de ayuda,
                                                    pregunta si necesita ayuda antes de actuar.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Evitar apodos o chistes relacionados con la
                                                    discapacidad.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Evita miradas innecesarias a la persona con
                                                    discapacidad.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Evita juicios de valor relacionado con una
                                                    discapacidad.
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    No hacer comentarios que victimicen o dramaticen
                                                    la situación de discapacidad de cualquier
                                                    persona que se encuentre en este supuesto.
                                                </Text>
                                            </List.Item>
                                        </List.Root>
                                    </Stack>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/disabilities.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Flex direction={{ base: "column", md: "row" }} alignItems="center">
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        mt={8}
                                        textDecoration="underline"
                                    >
                                        Personas de la tercera edad
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Las personas de la tercera edad tienen derecho a una vida
                                        digna y sin discriminación. Así como a no ser objeto de
                                        agresiones contra su dignidad, honor y reputación. 
                                        <br />
                                        <br />
                                        En <strong>GRUPO GUIA</strong> reprobamos conductas que
                                        puedan ser consideradas discriminatorias por razón de la
                                        edad. 
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/elderly.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12} borderTop="1px solid #929292">
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                mt={8}
                            >
                                ESPACIOS LIBRES DE ACOSO, HOSTIGAMIENTO Y BULLYING
                            </Text>
                            <Text
                                fontSize={{ md: "md", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                            >
                                Prevención de acoso, hostigamiento y bullying
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                mt={6}
                            >
                                <strong>GRUPO GUIA</strong> podrá tener campañas y políticas
                                especializadas que busquen la prevención de conductas de acoso y
                                hostigamiento (en cualquiera de sus formas), así como bullying. 
                                <br />
                                <br />
                                Conocer e informarse sobre lo que es acoso, hostigamiento y bullying
                                puede ayudar a mantener un ambiente sano. Si usted participa o
                                realiza en forma directa actos de acoso y hostigamiento contra
                                terceros, así como bullying será personalmente responsable. 
                                <br />
                                <br />
                                Las conductas a veces pueden ser realizadas por alguien externo a la
                                organización. Por favor denuncie. Ser testigo o tener conocimiento
                                de una conducta y no reportarla lo podría colocar en una situación
                                de responsabilidad. 
                            </Text>
                            <Stack
                                borderWidth={1}
                                borderColor="#A3A3A3"
                                borderRadius="md"
                                px={10}
                                py={6}
                            >
                                <Text
                                    fontSize={{ md: "lg", base: "sm" }}
                                    textAlign="start"
                                    color="accent.500"
                                    fontWeight={400}
                                    pb={2}
                                >
                                    Ejemplos de acoso y hostigamiento:
                                </Text>
                                <List.Root gap={2} fontWeight={800} pl={4} pb={2} ml={4}>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Comentarios hostiles contra una persona, ya sea en su
                                            presencia o en su ausencia.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Ataques físicos o amenazas contra una o un grupo de
                                            personas.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Buscar intimidar a una persona para evitar realice una
                                            denuncia o bien desista de ésta.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Gestos sexuales evidentes.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Ofensas
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Ofrecer beneficios o promociones a cambio de un favor
                                            sexual.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Ignorar a una persona, no hablarle, excluirla.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Aislar o negar la presencia de una persona.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Esparcir mentiras o chismes sobre una persona.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Contacto físico inapropiado y no autorizado por la
                                            persona.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Presionar con mensajes en distintos canales de
                                            comunicación, en forma reiterada durante un corto
                                            periodo de tiempo, preguntando por el estatus del
                                            servicio solicitado. En la misma forma cuando se de
                                            instrucciones al mismo tiempo a distintas personas de
                                            estar haciendo seguimiento hasta recibir el servicio.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Buscar ridiculizar ante cualquier error a la persona que
                                            lo comete.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Enviar mensajes por cualquier medio de comunicación que
                                            atenten contra la dignidad de una persona.
                                        </Text>
                                    </List.Item>
                                    <List.Item>
                                        <Text fontWeight={400} color="accent.500">
                                            Criticar la forma de trabajo de una persona en su
                                            ausencia, que implique un daño en su reputación.
                                        </Text>
                                    </List.Item>
                                </List.Root>
                            </Stack>
                        </Stack>
                        <Stack mb={4} mt={12} bg="#F5F5F5" borderRadius="md" px={10} py={6}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/leader.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                    >
                                        Si tú eres líder de equipo:
                                    </Text>
                                    <List.Root gap={1} fontWeight={800} pl={4} pb={2} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Fomenta la integración.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Proporciona escucha activa a las personas de tu
                                                equipo que busquen conversar sobre estos temas. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Inicia la denuncia interna cuando se trate de una
                                                conducta inapropiada grave.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                mt={8}
                            >
                                Abordar conductas sexuales inapropiadas
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                mt={6}
                            >
                                Un primer paso para evitar que el ambiente y espacio de trabajo se
                                vea afectado por conductas sexuales inapropiadas es identificarlas. 
                                <br />
                                Estas conductas se pueden dar en forma oral, no oral o física.
                                Recibir mensajes por escrito y electrónicos con palabras y/o
                                imágenes que atenten contra la dignidad humana o sean consideradas
                                por el común denominador como sexuales es una forma de recibir
                                acoso. 
                                <br />
                                <br />
                                Ante la primer mirada, comentario, mensaje o contacto físico que te
                                incomode tienes derecho a solicitar no se repita. Al recibir un no y
                                continuar haciéndolo, se presumirá existe intención y se considera
                                reincidencia. 
                                <br />
                                <br />
                                La conducta sexual inapropiada se entiende no solamente entre
                                personas con distintas jerarquías, basta que la recibas por parte de
                                una persona que tiene relación contigo motivado por los derechos u
                                obligaciones que tienes con GRUPO GUIA. 
                                <br />
                                <br />
                                Las conductas sexuales inapropiadas se pueden realizar entre
                                personas de distinto o mismo sexo y puede ocurrirle a cualquier
                                persona. 
                                <br />
                                Cualquier conducta sexual inapropiada que se identifique por
                                cualquier persona en contra de una persona que guarda relación con
                                GRUPO GUIA debe denunciarse. 
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Grid
                                        templateColumns={{
                                            base: "repeat(2, 1fr)",
                                            md: "repeat(3, 1fr)",
                                        }}
                                        gap={0}
                                    >
                                        <GridItem
                                            colSpan={1}
                                            borderWidth={1}
                                            borderColor="#A3A3A3"
                                            alignContent="center"
                                            alignItems="center"
                                            p={4}
                                        >
                                            <Text
                                                fontSize={{ md: "md", base: "sm" }}
                                                textAlign="center"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mt={6}
                                            >
                                                Acoso sexual
                                            </Text>
                                        </GridItem>
                                        <GridItem
                                            colSpan={{ base: 1, md: 2 }}
                                            borderWidth={1}
                                            borderColor="#A3A3A3"
                                            alignContent="center"
                                            alignItems="center"
                                            p={4}
                                        >
                                            <List.Root
                                                gap={0}
                                                fontWeight={800}
                                                pl={4}
                                                pb={2}
                                                ml={4}
                                            >
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Solicitar favores con fines lascivos 
                                                    </Text>
                                                </List.Item>
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Utilizar un lenguaje sexualmente implícito 
                                                    </Text>
                                                </List.Item>
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Expresar un deseo de contacto con fines
                                                        lascivos 
                                                    </Text>
                                                </List.Item>
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Hablar en tono sexual 
                                                    </Text>
                                                </List.Item>
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Utilizar apodos o términos cariños con
                                                        connotaciones sexuales 
                                                    </Text>
                                                </List.Item>
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Comentar el aspecto de una persona 
                                                    </Text>
                                                </List.Item>
                                            </List.Root>
                                            <Text
                                                fontSize={{ md: "md", base: "sm" }}
                                                textAlign="start"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mt={6}
                                            >
                                                No todos los comentarios tienen una intención
                                                lasciva ni son con el fin de obtener algo por parte
                                                de otra persona. Es necesario utilizar el sentido
                                                común tanto para entender cuándo no existe una
                                                conducta inapropiada tanto como para cuidar el
                                                ambiente y la forma en que se hace un comentario. 
                                            </Text>
                                        </GridItem>
                                        <GridItem
                                            colSpan={1}
                                            borderWidth={1}
                                            borderColor="#A3A3A3"
                                            alignContent="center"
                                            alignItems="center"
                                            p={4}
                                        >
                                            <Text
                                                fontSize={{ md: "md", base: "sm" }}
                                                textAlign="center"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mt={6}
                                            >
                                                Acoso sexual no verbal
                                            </Text>
                                        </GridItem>
                                        <GridItem
                                            colSpan={{ base: 1, md: 2 }}
                                            borderWidth={1}
                                            borderColor="#A3A3A3"
                                            alignContent="center"
                                            alignItems="center"
                                            p={4}
                                        >
                                            <List.Root
                                                gap={0}
                                                fontWeight={800}
                                                pl={4}
                                                pb={2}
                                                ml={4}
                                            >
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Gestos con connotación sexual realizados a
                                                        una persona sin su consentimiento. 
                                                    </Text>
                                                </List.Item>
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Proyección de contenido sexual frente a una
                                                        persona sin su consentimiento. 
                                                    </Text>
                                                </List.Item>
                                            </List.Root>
                                        </GridItem>
                                        <GridItem
                                            colSpan={1}
                                            borderWidth={1}
                                            borderColor="#A3A3A3"
                                            alignContent="center"
                                            alignItems="center"
                                            p={4}
                                        >
                                            <Text
                                                fontSize={{ md: "md", base: "sm" }}
                                                textAlign="center"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mt={6}
                                            >
                                                Contacto sexual físico
                                            </Text>
                                        </GridItem>
                                        <GridItem
                                            colSpan={{ base: 1, md: 2 }}
                                            borderWidth={1}
                                            borderColor="#A3A3A3"
                                            alignContent="center"
                                            alignItems="center"
                                            p={4}
                                        >
                                            <List.Root
                                                gap={0}
                                                fontWeight={800}
                                                pl={4}
                                                pb={2}
                                                ml={4}
                                            >
                                                <List.Item>
                                                    <Text fontWeight={400} color="accent.500">
                                                        Tocamientos con connotación sexual sin
                                                        consentimiento.
                                                    </Text>
                                                </List.Item>
                                            </List.Root>
                                        </GridItem>
                                    </Grid>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/harassment.svg"
                                        maxW="90%"
                                        h="auto"
                                        w="90%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                mt={8}
                            >
                                CUMPLIMIENTO NORMATIVO Y ANTICORRUPCIÓN
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                mt={6}
                            >
                                En <strong>GRUPO GUIA</strong> respetamos la normativa y trabajamos
                                bajo una cultura de cumplimiento. Cualquier persona que teniendo
                                conocimiento de las obligaciones legales de{" "}
                                <strong>GRUPO GUIA</strong> que actúe en contravención, será
                                responsable en forma directa frente a autoridades y frente a
                                terceros. 
                                <br />
                                Conocer sobre cualquier acto, o simplemente tener la sospecha, de un
                                acto realizado por cualquier persona que tenga relación con GRUPO
                                GUIA que pueda tener un impacto financiero negativo en la compañía,
                                en su reputación o incluso implique una responsabilidad penal,
                                deberá ser denunciado en forma inmediata a través de nuestros
                                canales de denuncia. 
                                <br />
                                <br />
                                Nadie puede obligarte a realizar un acto contrario a la ley. Por
                                favor informa de manera inmediata cuando ocurra esta situación
                                directamente a los canales que menciona este documento. 
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                pb={2}
                                mt={6}
                                textDecoration="underline"
                            >
                                Confidencialidad
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                mt={6}
                            >
                                Mantener la confidencialidad es importante para el cumplimiento
                                normativo. Es importante no divulgar la información que con motivo
                                de nuestras actividades relacionadas con <strong>GRUPO GUIA</strong>{" "}
                                obtenemos.  
                                <br />
                                No debemos preguntar a personas relacionadas con{" "}
                                <strong>GRUPO GUIA</strong> situaciones sobre personas, datos
                                financieros, datos personales, información comercial, bases de datos
                                y en general aquella que se encuentre protegida con carácter
                                confidencial, para asuntos no relacionados con las funciones que
                                debemos realizar. 
                                <br />
                                <br />
                                Mantener la confidencialidad es parte fundamental de la operación de
                                cada trabajador, comisionista, prestador de servicios y en general
                                persona en contacto con información privilegiada. 
                                <br />
                                <br />
                                Si eres nuevo colaborador, por favor no nos reveles información
                                confidencial de tu antiguo empleador, así como esperamos no reveles
                                información de <strong>GRUPO GUIA</strong> cuando decidas iniciar
                                con un nuevo empleador. 
                                <br />
                                <br />
                                Por favor si notas o sospechas una persona está divulgando o se
                                encuentra por divulgar información confidencial, denuncia de
                                inmediato a los canales de denuncia mencionados en este documento. 
                                <br />
                                <br />
                                Ante la duda sobre si una información es confidencial o no, debes
                                otorgar trato de confidencial. 
                                <br />
                                <br />
                                Trato confidencial implica no poder divulgar en ninguna forma la
                                información, ya sea oral, escrita o por cualquier medio, en forma
                                total o parcial. 
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Text
                                fontSize={{ md: "xl", base: "md" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={600}
                                mt={8}
                            >
                                Conflictos de intereses
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                textAlign="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                                mt={6}
                            >
                                Comprender los conflictos de intereses es esencial para evitar caer
                                en él. Existe conflicto de interés cuando tu decisión profesional se
                                pueda ver afectada por tus intereses personales.
                                <br />
                                <br />
                                Es necesario que ante cualquier situación que implique tu juicio se
                                vea influenciado por un interés personal, dejando así de ser
                                imparcial ante una situación en particular, seas la primera persona
                                que lo reconozca y lo expreses de esa forma, primero con tu líder de
                                área, buscando un plan de acción. 
                            </Text>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack borderWidth={1} borderColor="#A3A3A3" borderRadius={8} p={8}>
                                    <Text
                                        fontSize={{ md: "md", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                    >
                                        Ejemplo de conflicto de interés:
                                    </Text>
                                    <List.Root gap={2} fontWeight={800} pl={4} pb={2} ml={4}>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Influir en la toma de decisión respecto a la
                                                contratación de un producto o servicio en la que un
                                                amigo o familiar tiene interés económico, con la
                                                única de intención de beneficiar al amigo o
                                                familiar. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                No informar al departamento de talento se ha
                                                contratado o se encuentra en proceso de entrevista
                                                un familiar. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Colocar a familiares en situación de subordinación
                                                directa o con autoridad de toma de decisiones sobre
                                                el otro. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Involucrarse en una relación romántica con una
                                                persona que supervisas directamente o sobre quien
                                                tienes la capacidad de influir en sus ingresos,
                                                calificación en su desempeño y cualquier otra
                                                decisión laboral.  
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Hacer trabajo de medio tiempo a clientes o
                                                proveedores directos de <strong>GRUPO GUIA</strong>
                                                . 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Hacer trabajo para la competencia de{" "}
                                                <strong>GRUPO GUIA</strong> en aquello que pueda
                                                implicar la transmisión de conocimientos o la misma
                                                línea de asesoría estratégica para ambas partes. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Competir con <strong>GRUPO GUIA</strong> en
                                                cualquiera de sus formas. 
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Tomar una oportunidad de negocios o hacerlo a través
                                                de una persona moral, familiares, amigos, sin
                                                primero haber dado prioridad a{" "}
                                                <strong>GRUPO GUIA</strong>.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text fontWeight={400} color="accent.500">
                                                Atender primero las peticiones de los amigos dentro
                                                de la empresa, dándole un trato preferencial frente
                                                a los demás. 
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/interest.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/gifts.svg"
                                        maxW="90%"
                                        h="auto"
                                        w="90%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        mt={8}
                                    >
                                        Regalos y pagos inapropiados
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mt={6}
                                    >
                                        En nuestra cultura es permitido que busquemos dar un
                                        agradecimiento o muestra de cariño a través de regalos o
                                        pagos. Sin embargo, ésta buena intención podría traer como
                                        consecuencia la malinterpretación de ser entregada como un
                                        soborno. 
                                        <br />
                                        <br />
                                        Es importante que cualquier servicio que se reciba en la
                                        compañía, ya sea en forma interna o externa se realice o se
                                        reciba sin la expectativa de recibir nada a cambio que la
                                        contraprestación que hubiere sido previamente pactada. 
                                        <br />
                                        <br />
                                        Piensa que cuando tú das un regalo o pago, por mínimo que
                                        sea, podría implicar que la persona que lo recibe comience a
                                        darte un trato preferencial, lo que la pondría en un
                                        conflicto de intereses. 
                                    </Text>
                                    <Stack
                                        borderWidth={1}
                                        borderColor="#A3A3A3"
                                        borderRadius={8}
                                        p={8}
                                    >
                                        <Text
                                            fontSize={{ md: "md", base: "md" }}
                                            textAlign="start"
                                            color="accent.500"
                                            fontWeight={600}
                                        >
                                            Antes de recibir o dar un regalo o pago, pregúntate lo
                                            siguiente:
                                        </Text>
                                        <List.Root gap={0} fontWeight={800} pl={4} pb={2} ml={4}>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Está prohibido por la ley?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Se puede considerar un soborno?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Se hizo con la intención de influir en una
                                                    decisión?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    Al aceptarlo ¿Me compromete a algo?
                                                </Text>
                                            </List.Item>
                                            <List.Item>
                                                <Text fontWeight={400} color="accent.500">
                                                    ¿Cómo se percibiría si se divulgara
                                                    públicamente?
                                                </Text>
                                            </List.Item>
                                        </List.Root>
                                    </Stack>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mb={4} mt={12}>
                            <Flex direction={{ base: "column", md: "row" }}>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "xl", base: "md" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={600}
                                        mt={8}
                                    >
                                        Responsabilidad financiera
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        mt={6}
                                    >
                                        Debes apegarte a las políticas establecida por{" "}
                                        <strong>GRUPO GUIA</strong> para todo aquello relacionado
                                        con los ingresos y egresos de la empresa. 
                                        <br />
                                        <br />
                                        Te recordamos no podemos recibir cantidades en efectivo,
                                        cheques o valores relacionados con la transacción que
                                        realiza un comprador con un vendedor.{" "}
                                        <strong>GRUPO GUIA</strong> es intermediario. Conoce la
                                        política de no manejo de
                                        <br />
                                        <br />
                                        Cuando requieras viáticos, necesitas apegarte al presupuesto
                                        e instrucciones otorgadas por <strong>GRUPO GUIA</strong>.
                                        Falsificar gastos o incluir gastos no relacionados con
                                        viáticos puede traer una sanción que será determinada por el
                                        Comité de Ética. 
                                        <br />
                                        <br />
                                        Es importante que denuncies a cualquier persona  que
                                        detectes comience a indagar sobre datos financieros de{" "}
                                        <strong>GRUPO GUIA</strong>, no relacionados con sus
                                        funciones. 
                                        <br />
                                        <br />
                                    </Text>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        textAlign="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        fontStyle="italic"
                                    >
                                        Fecha de última actualización: 30 de septiembre de 2024
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "45%" }} alignSelf="center" pl={8}>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/financial-responsibility.svg"
                                        maxW="90%"
                                        h="auto"
                                        w="90%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack
                            alignContent="center"
                            justifyContent="center"
                            w="100%"
                            alignItems="center"
                        >
                            <Button
                                bg="accent.500"
                                color="white"
                                borderRadius="md"
                                fontWeight={500}
                                onClick={handleDownload}
                                px={4}
                            >
                                Haz tu denuncia
                            </Button>
                        </Stack>
                    </Box>
                </Flex>
            </Container>
            <Footer esGuiaRent={false} />
        </>
    );
};

export default CodigoConducta;
